// extracted by mini-css-extract-plugin
export var addButton = "_dx-0";
export var border = "_dx-8";
export var check = "_dx-h";
export var danger = "_dx-6";
export var dropdownContainer = "_dx-1";
export var editModalBody = "_dx-j";
export var footerContainer = "_dx-i";
export var fullWidth = "_dx-a";
export var hide = "_dx-9";
export var icon = "_dx-3";
export var input = "_dx-7";
export var inputFlex = "_dx-b";
export var inputWrapper = "_dx-c";
export var manualFocus = "_dx-5";
export var optionButton = "_dx-4";
export var pillWrapper = "_dx-e";
export var pointer = "_dx-2";
export var showOverflow = "_dx-f";
export var tagsFlex = "_dx-d";
export var xButton = "_dx-g";